import { Base } from "ui/Scripts/source/framework/base";
import { IdCodeNameLogo, IIdCodeNameLogo } from "../common/idCodeNameLogo";
import { IUserProfile, UserProfile } from "./userProfile";

export interface IUserProfileEdit {
    user: IUserProfile;
    minPasswordLength: number;
    allowedCompanies: IIdCodeNameLogo[];
}

export class UserProfileEdit implements IUserProfileEdit {
    user: UserProfile;
    minPasswordLength: number;
    allowedCompanies: IdCodeNameLogo[];

    constructor();
    constructor(obj: IUserProfileEdit);
    constructor(obj?: any) {
        this.user = new UserProfile(obj?.user);
        this.minPasswordLength = obj && obj.minPasswordLength || 0;
        this.allowedCompanies = Base.getTypedArray(obj?.allowedCompanies, IdCodeNameLogo);
    }
}